/**
 *
 * AdministratorBCDxGridContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as actionCreators from './actions';
import {requestAction} from "domain/typeConstants/action";

class AdministratorBCDxGridContainerBase extends React.PureComponent {

    handleRowDoubleClick = (record) => this.props.executeEditAction(record.id);

    handleActionExecuting = (actionName, ids) => {
        switch (actionName) {
            case requestAction.EDIT:
                this.props.executeEditAction(ids[0]);
                break;
            case requestAction.VIEW:
                this.props.executeViewAction(ids[0]);
                break;
            default:
                throw new Error('Executed a unknown action.');
        }
    };

    render() {
        const {component, viewName} = this.props;
        return React.cloneElement(component, {
            viewName,
            onActionExecuting: this.handleActionExecuting,
            onRowDoubleClick: this.handleRowDoubleClick,
        });
    }
}

AdministratorBCDxGridContainerBase.propTypes = {
    component: PropTypes.node.isRequired,
    viewName: PropTypes.string.isRequired,
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

export const AdministratorBCDxGridContainer = connect(null, mapDispatchToProps)(AdministratorBCDxGridContainerBase);
